// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8a69679d","977":"447eaca6"}[chunkId] + ".chunk.js";
};